module.exports = __webpack_public_path__ + "img/III.ce59fc2c.svg";